import React from 'react';

/** Text input with optional label + hint. */
export default function Input({ label, hint, error, iconLeft, style, id, ...rest }) {
  // React.useId guarantees uniqueness when two same-labeled fields render; explicit id still wins.
  const autoId = React.useId();
  const inputId = id || 'in-' + autoId;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}>
      {label && (
        <label htmlFor={inputId} style={{
          fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-medium)', fontSize: 'var(--text-sm)',
          letterSpacing: 'var(--track-tight)', color: 'var(--ink)',
        }}>{label}</label>
      )}
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {iconLeft && (
          <span style={{ position: 'absolute', left: 14, display: 'inline-flex', color: 'var(--ink-faint)' }}>
            {iconLeft}
          </span>
        )}
        <input
          id={inputId}
          style={{
            width: '100%', height: 44, padding: iconLeft ? '0 14px 0 40px' : '0 14px',
            fontFamily: 'var(--font-sans)', fontSize: 'var(--text-base)', letterSpacing: 'var(--track-tight)',
            color: 'var(--ink)', background: 'var(--neutral-0)',
            border: `1.5px solid ${error ? 'var(--human-500)' : 'var(--line-strong)'}`,
            borderRadius: 'var(--radius-md)', outline: 'none',
            transition: 'border-color var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out)',
          }}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = 'var(--ink)';
            e.currentTarget.style.boxShadow = '0 0 0 3px var(--human-50)';
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = error ? 'var(--human-500)' : 'var(--line-strong)';
            e.currentTarget.style.boxShadow = 'none';
          }}
          {...rest}
        />
      </div>
      {(hint || error) && (
        <span style={{
          fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)',
          color: error ? 'var(--human-600)' : 'var(--ink-muted)',
        }}>{error || hint}</span>
      )}
    </div>
  );
}
